module.exports = __webpack_public_path__ + "img/03_sub_no.c2d1518c.svg";